<template>
  <svg height="15" width="15">
    <circle :cx="left" :cy="top" r="3" fill="red" />
  </svg>
</template>

<script>
export default {
  name: 'LicenseCheckerCircle',
  props: {
    top: { type: Number, default: 0 },
    left: { type: Number, default: 0 }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/license-checker/license-checker-circle.vue